function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNybbleLogoFullColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M125.46,108.88l-24.55,42.76,24.55,42.83h49.1l24.55-42.76L174.56,108.9Z",
    style: {
      fill: "#264653"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.51,0,105,39.21l22.51,39.21h45L195,39.21,172.51,0Z",
    style: {
      fill: "#db6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,75.46l15.86,42.48,43.91,6.41,28.07-36.08L91.7,45.79,47.77,39.38Z",
    style: {
      fill: "#e9c46a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,208.93l42.28,13.8,32.29-31.22-10-45-42.28-13.8L0,163.93Z",
    style: {
      fill: "#2a9d8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69,300l36.87-25.29-3.66-45.32L98.34,209.28l-36.85,25.3,3.66,45.31Z",
    style: {
      fill: "#db6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.73,280.07l3.72-45.31-36.84-25.33-40.55,20-3.72,45.31L194.2,300Z",
    style: {
      fill: "#f4a261"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,164.18l-32.16-31.33-42.29,13.74-10.08,45,32.24,31.26L290,209.08Z",
    style: {
      fill: "#e9c46a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.4,39.53l-43.93,6.35L192.56,88.32l28,36.1,44-6.34,15.9-42.48Z",
    style: {
      fill: "#2a9d8f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNybbleLogoFullColor);
export default __webpack_public_path__ + "static/media/Nybble-Logo-Full-Color.e6835b3f0fe1db8040483428c9609588.svg";
export { ForwardRef as ReactComponent };